import { StreakData } from '@/types/gamification';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Flame, Calendar, TrendingUp } from 'lucide-react';

interface StreakTrackerProps {
  streak: StreakData;
  variant?: 'compact' | 'detailed';
}

export const StreakTracker = ({ streak, variant = 'detailed' }: StreakTrackerProps) => {
  if (variant === 'compact') {
    return (
      <Card className="bg-gradient-to-r from-orange-500/10 to-red-500/10">
        <CardContent className="p-4 flex items-center gap-4">
          <div className="w-12 h-12 rounded-full bg-gradient-to-br from-orange-500 to-red-500 flex items-center justify-center">
            <Flame className="w-6 h-6 text-white" />
          </div>
          <div>
            <p className="text-2xl font-bold">{streak.currentStreak}</p>
            <p className="text-sm text-muted-foreground">Day Streak</p>
          </div>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card className="bg-gradient-to-br from-orange-500/10 to-red-500/10">
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Flame className="w-5 h-5 text-orange-500" />
          Your Learning Streak
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="grid grid-cols-3 gap-4">
          <div className="text-center p-4 rounded-lg bg-card">
            <div className="text-3xl font-bold text-orange-500 mb-1">
              {streak.currentStreak}
            </div>
            <div className="text-xs text-muted-foreground flex items-center justify-center gap-1">
              <Flame className="w-3 h-3" />
              Current Streak
            </div>
          </div>
          
          <div className="text-center p-4 rounded-lg bg-card">
            <div className="text-3xl font-bold text-primary mb-1">
              {streak.longestStreak}
            </div>
            <div className="text-xs text-muted-foreground flex items-center justify-center gap-1">
              <TrendingUp className="w-3 h-3" />
              Best Streak
            </div>
          </div>
          
          <div className="text-center p-4 rounded-lg bg-card">
            <div className="text-3xl font-bold text-secondary mb-1">
              {streak.totalDaysActive}
            </div>
            <div className="text-xs text-muted-foreground flex items-center justify-center gap-1">
              <Calendar className="w-3 h-3" />
              Total Days
            </div>
          </div>
        </div>

        <div className="text-sm text-muted-foreground text-center pt-2 border-t">
          {streak.currentStreak > 0 ? (
            <p>Keep it up. Come back tomorrow to maintain your streak.</p>
          ) : (
            <p>Start your learning journey today.</p>
          )}
        </div>
      </CardContent>
    </Card>
  );
};
